module.exports = __webpack_public_path__ + "static/media/1.cfc29974.png";